"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _form = _interopRequireDefault(require("./form"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// A generic object without any required structure
var ObjectForm = /*#__PURE__*/function (_Form) {
  (0, _inherits2.default)(ObjectForm, _Form);

  var _super = _createSuper(ObjectForm);

  function ObjectForm(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ObjectForm);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'ObjectForm');
    _this._errorFromSet = null;
    return _this;
  }

  (0, _createClass2.default)(ObjectForm, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(ObjectForm.prototype), "_create", this).call(this, Object.assign(props, {
        omitDefaultFields: true
      })); // The fields are dynamic so we need to disable the undefined check

      this._set('reportUndefined', false);
    }
  }, {
    key: "setValues",
    value: function setValues(values) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(ObjectForm.prototype), "setValues", this).call(this, values);
      this._errorFromSet = null;
      this._valueSet = values;
    } // Needed as value is not stored in value property

  }, {
    key: "isBlank",
    value: function isBlank() {
      return this._valueSet ? false : true;
    }
  }, {
    key: "getErrs",
    value: function getErrs() {
      var errs = (0, _get2.default)((0, _getPrototypeOf2.default)(ObjectForm.prototype), "getErrs", this).call(this);

      if (this._errorFromSet !== null) {
        errs = errs.concat({
          error: this._errorFromSet
        });
      }

      return errs;
    }
  }]);
  return ObjectForm;
}(_form.default);

exports.default = ObjectForm;